import { render } from "./SearchVouchersView.vue?vue&type=template&id=6a9f8e6d&ts=true"
import script from "./SearchVouchersView.vue?vue&type=script&lang=ts"
export * from "./SearchVouchersView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_typescript@4.9.5__webpack@5.109.2_postcss@8.5.25_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__